import PhotoCameraOutlinedIcon from "@mui/icons-material/PhotoCameraOutlined";
import { Button, SxProps, Theme } from "@mui/material";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

interface CaptureLiveImageButtonProps {
  disabled: boolean;
  onClick: () => void;
  buttonStyles?: SxProps<Theme>;
}

const CaptureLiveImageButton = ({
  disabled,
  onClick,
  buttonStyles,
}: CaptureLiveImageButtonProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        marginRight: "0.5em",
        marginBottom: "0.5em",
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <Button
        disabled={disabled}
        variant="text"
        size="small"
        startIcon={<PhotoCameraOutlinedIcon />}
        color="inherit"
        onClick={onClick}
        sx={{
          "&.Mui-disabled": {
            backgroundColor: "transparent",
            color: theme.palette.text.disabled,
          },
          ":hover": {
            backgroundColor: "transparent",
          },
          ...buttonStyles,
        }}
      >
        Capture Live Image
      </Button>
    </Box>
  );
};

export default CaptureLiveImageButton;
